/* eslint-disable camelcase */
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var receivablesByMaturityColumns = [{
  name: 'Кр. посредник',
  value: 'franchisee_name',
  width: '110px'
}, {
  name: 'Офис',
  value: 'office_name',
  width: '110px'
}, {
  name: 'Главници до 1 сед.',
  render: function render(_ref) {
    var total_late_principals_1_week = _ref.total_late_principals_1_week,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_principals_1_week"
    }, total_late_principals_1_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Лихви до 1 сед.',
  render: function render(_ref2) {
    var total_late_interests_1_week = _ref2.total_late_interests_1_week,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_interests_1_week"
    }, total_late_interests_1_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Такси до 1 сед.',
  render: function render(_ref3) {
    var total_late_fees_1_week = _ref3.total_late_fees_1_week,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_fees_1_week"
    }, total_late_fees_1_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Общо до 1 сед.',
  render: function render(_ref4) {
    var total_late_1_week = _ref4.total_late_1_week,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_1_week"
    }, total_late_1_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Главници до 2 сед.',
  render: function render(_ref5) {
    var total_late_principals_2_week = _ref5.total_late_principals_2_week,
        currency = _ref5.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_principals_2_week"
    }, total_late_principals_2_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Лихви до 2 сед.',
  render: function render(_ref6) {
    var total_late_interests_2_week = _ref6.total_late_interests_2_week,
        currency = _ref6.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_interests_2_week"
    }, total_late_interests_2_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Такси до 2 сед.',
  render: function render(_ref7) {
    var total_late_fees_2_week = _ref7.total_late_fees_2_week,
        currency = _ref7.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_fees_2_week"
    }, total_late_fees_2_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Общо до 2 сед.',
  render: function render(_ref8) {
    var total_late_2_week = _ref8.total_late_2_week,
        currency = _ref8.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_2_week"
    }, total_late_2_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Главници до 3 сед.',
  render: function render(_ref9) {
    var total_late_principals_3_week = _ref9.total_late_principals_3_week,
        currency = _ref9.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_principals_3_week"
    }, total_late_principals_3_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Лихви до 3 сед.',
  render: function render(_ref10) {
    var total_late_interests_3_week = _ref10.total_late_interests_3_week,
        currency = _ref10.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_interests_3_week"
    }, total_late_interests_3_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Такси до 3 сед.',
  render: function render(_ref11) {
    var total_late_fees_3_week = _ref11.total_late_fees_3_week,
        currency = _ref11.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_fees_3_week"
    }, total_late_fees_3_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Общо до 3 сед.',
  render: function render(_ref12) {
    var total_late_3_week = _ref12.total_late_3_week,
        currency = _ref12.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_3_week"
    }, total_late_3_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Главници до 4 сед.',
  render: function render(_ref13) {
    var total_late_principals_4_week = _ref13.total_late_principals_4_week,
        currency = _ref13.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_principals_4_week"
    }, total_late_principals_4_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Лихви до 4 сед.',
  render: function render(_ref14) {
    var total_late_interests_4_week = _ref14.total_late_interests_4_week,
        currency = _ref14.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_interests_4_week"
    }, total_late_interests_4_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Такси до 4 сед.',
  render: function render(_ref15) {
    var total_late_fees_4_week = _ref15.total_late_fees_4_week,
        currency = _ref15.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_fees_4_week"
    }, total_late_fees_4_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Общо до 4 сед.',
  render: function render(_ref16) {
    var total_late_4_week = _ref16.total_late_4_week,
        currency = _ref16.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_4_week"
    }, total_late_4_week, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Главници до 5+ сед.',
  render: function render(data) {
    return ___EmotionJSX("span", {
      "data-value": "total_late_principals_5+_week"
    }, data === null || data === void 0 ? void 0 : data['total_late_principals_5+_week'], " ", data === null || data === void 0 ? void 0 : data.currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Лихви до 5+ сед.',
  render: function render(data) {
    return ___EmotionJSX("span", {
      "data-value": "total_late_interests_5+_week"
    }, data === null || data === void 0 ? void 0 : data['total_late_interests_5+_week'], " ", data === null || data === void 0 ? void 0 : data.currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Такси до 5+ сед.',
  render: function render(data) {
    return ___EmotionJSX("span", {
      "data-value": "total_late_fees_5+_week"
    }, data === null || data === void 0 ? void 0 : data['total_late_fees_5+_week'], " ", data === null || data === void 0 ? void 0 : data.currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Общо до 5+ сед.',
  render: function render(data) {
    return ___EmotionJSX("span", {
      "data-value": "total_late_5+_week"
    }, data === null || data === void 0 ? void 0 : data['total_late_5+_week'], " ", data === null || data === void 0 ? void 0 : data.currency);
  },
  invisibleBelow: 3000
}];